let officesPromise = null

export const getOfficesPromise = () => officesPromise

export const setOfficesPromise = (promise) => {
  officesPromise = promise
}

export const resetOfficesCache = () => {
  officesPromise = null
}
